import { APIClient } from "../../../../api/api_helper";
import { Aliquot_API } from "../../../../api/url_helper";
import { GetUserData } from "../../../../common/service/CommonService";
import { AliquotFormValues } from "../helper/aliquote.types";

interface CurrentUser {
  userid: number;

}

const api = new APIClient();

export const aliquotApiService = {
  // SELECT ALL METHOD
  getSelectAllData: (
    searchText?: string | null,
    pageNumber: number = 1,
    pageSize: number = 10,
  ) => {
    const payload = {
      status: "A",
      searchtext: searchText || null,
      currentpage: pageNumber,
      pagesize: pageSize,
    };
    return api.create(Aliquot_API.Aliquot_API + "SelectAll", payload);
  },

  // SELECT METHOD
  getSelectData: (id: number | undefined | null) => {
    return api.create(Aliquot_API.Aliquot_API + "Select", {
      id: id,
    });
  },

  insertData: (payload_data: AliquotFormValues) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      aliquot_sort: payload_data.aliquot_sort,
      aliquot_number: payload_data.aliquot_number,
      createdby: user.userid,
    };
    return api.create(Aliquot_API.Aliquot_API + "Insert", payload);
  },

  updateData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      aliquotid: payload_data.aliquotid,
      aliquot_sort: payload_data.aliquot_sort,
      aliquot_number: payload_data.aliquot_number,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(Aliquot_API.Aliquot_API + "Update", payload);
  },

  // DELETE METHOD
  deleteData: (payload_data: { aliquotid: number; updatereason: string }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      aliquotid: payload_data.aliquotid,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(Aliquot_API.Aliquot_API + "Delete", payload);
  },
};
